var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header',{ref:"Header",attrs:{"select-index":_vm.HeaderIndex}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"appList"}},[_c('router-view',{ref:_vm.childRouteName})],1),_vm._v(" "),(_vm.showHeader)?_c('Footer',{attrs:{"no-bg":false}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8074dee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 